const PullPullingText = '下拉即可刷新...'
const PullLoadingText = '加载中...'
const PullLoosingText = '释放即可刷新...'

const PushFinishedText = '没有更多了'
const PushLoadingText  = '加载中...'
const PushErrorText    = '加载失败，稍后再试...'

export { PullPullingText, PullLoadingText, PullLoosingText, PushFinishedText, PushLoadingText, PushErrorText}